export default __webpack_public_path__ + "static/media/23.93520b3b.svg";